import orderInstance from '../instance'

const confirmOrder = (orderId, data) => {
  return orderInstance.post('/orders/' + orderId + '/confirm', data)
}

export default confirmOrder
